



























































import { editFactory } from '@/main/pages';
import { editName } from '@/main/store/listEditTypes';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
import { SkladMisto } from '@/modules/ciselnik/skladove/skladoveMisto';

import { OrganizacniJednotky } from '@/modules/administrace/organizacniJednotky';

import { PageMode } from '@/main/utils/pageMode';

import { editMutations } from './store/types';
import { store } from './store/edit';
import { NAME } from './constants';
import { apiProvider } from './api';
import { showAlert } from '@/main/utils/notifications';

export default editFactory(NAME, store).extend({
	name: editName(NAME),
	components: {
		DealerSelect: OrganizacniJednotky.components.Select,
		SkladMistoSelect: SkladMisto.components.Select,
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
	},
	watch: {
		OrgUnitId: {
			immediate: true,
			async handler(val, oldVal) {
				if (val) {
					this.startLoading();
					const { data } = await apiProvider.getWorkshopByOrgUnitId(val);
					this.dropdownList.ProvozovnaId = data;
					this.endLoading();
				}
			},
		},
	},
	data() {
		return {
			BulkIntStartTime: '00:00',
			BulkIntEndTime: '23:30',
		};
	},
	computed: {
		mutationsMappers() {
			return {
				nakladoveStredisko: `${this.storeUri}/${editMutations.SKLAD_NAKLADOVE_STREDISKO_SELECT_MAPPER}`,
				skladMisto: `${this.storeUri}/${editMutations.SKLAD_MISTO_SELECT_MAPPER}`,
				dealerKVPSCode: `${this.storeUri}/${editMutations.DEALERKVPS_SELECT_MAPPER}`,
			};
		},
		skladmistoFilter() {
			return {
				SkladOzn: this.SkladOzn,
				VyrazenPrp: false,
			};
		},
		naklStredFilter() {
			return {
				ProvozovnaId: this.ProvozovnaId,
				VyrazenPrp: false,
			};
		},
		isWareHouseVisible(): boolean {
			return !!this.OrgUnitId;
		},
		isWarehouseDisabled():boolean {
			return this.pageMode === PageMode.EDIT;
		},
	},
	methods: {
		async saveClick() {
			if (!this.OrgUnitId) {
				showAlert({
					message: this.LocalizeChyboveHlasky('msgWareHouseDealerNotSelected'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			
			// Add validation for BulkInventoryTime
			if (!this.BulkInventoryTime) {
				showAlert({
					message: this.LocalizeChyboveHlasky('msgBulkInventoryTimeRequired'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			
			await this.save();			
		},
	},
	
});
